import * as Joi from 'joi';

export const ResellerCreatePOSsSchema = Joi.object({
  partnerId: Joi.number().integer().min(1).optional().messages({
    'number.base': 'Partner is invalid.',
    'number.integer': 'Partner is invalid.',
    'number.min': 'Partner must must be at least 1.',
  }),
  resellerId: Joi.number().integer().min(1).optional().messages({
    'number.base': 'Reseller is invalid.',
    'number.integer': 'Reseller is invalid.',
    'number.min': 'Reseller must must be at least 1.',
  }),
  merchantId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Merchant is required.',
    'number.base': 'Merchant is invalid.',
    'number.integer': 'merchantId is invalid.',
    'number.min': 'merchantId must must be at least 1.',
  }),
  branchId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Branch is required.',
    'number.base': 'Branch is invalid.',
    'number.integer': 'Branch is invalid.',
    'number.min': 'Branch must must be at least 1.',
  }),

  posName: Joi.string().trim().required().messages({
    'any.required': 'POS name is required.',
    'string.base': 'POS name is invalid.',
    'string.empty': 'POS name is invalid.',
  }),
});

export const AdminCreatePOSsSchema = Joi.object({
  partnerId: Joi.number().integer().min(1).required().messages({
    'number.base': 'Partner is invalid.',
    'any.required': 'Partner is required.',
    'number.integer': 'Partner is invalid.',
    'number.min': 'Partner must must be at least 1.',
  }),
  resellerId: Joi.number().integer().min(1).required().messages({
    'number.base': 'Reseller is invalid.',
    'any.required': 'Reseller is required.',
    'number.integer': 'Reseller is invalid.',
    'number.min': 'Reseller must must be at least 1.',
  }),
  merchantId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Merchant is required.',
    'number.base': 'Merchant is invalid.',
    'number.integer': 'merchantId is invalid.',
    'number.min': 'merchantId must must be at least 1.',
  }),
  branchId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Branch is required.',
    'number.base': 'Branch is invalid.',
    'number.integer': 'Branch is invalid.',
    'number.min': 'Branch must must be at least 1.',
  }),

  posName: Joi.string().trim().required().messages({
    'any.required': 'POS name is required.',
    'string.base': 'POS name is invalid.',
    'string.empty': 'POS name is invalid.',
  }),
});

export const PartnerCreatePOSsSchema = Joi.object({
  partnerId: Joi.number().integer().min(1).optional().messages({
    'number.base': 'Partner is invalid.',
    'number.integer': 'Partner is invalid.',
    'number.min': 'Partner must must be at least 1.',
  }),
  resellerId: Joi.number().integer().min(1).required().messages({
    'number.base': 'Reseller is invalid.',
    'any.required': 'Reseller is required.',
    'number.integer': 'Reseller is invalid.',
    'number.min': 'Reseller must must be at least 1.',
  }),
  merchantId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Merchant is required.',
    'number.base': 'Merchant is invalid.',
    'number.integer': 'merchantId is invalid.',
    'number.min': 'merchantId must must be at least 1.',
  }),
  branchId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Branch is required.',
    'number.base': 'Branch is invalid.',
    'number.integer': 'Branch is invalid.',
    'number.min': 'Branch must must be at least 1.',
  }),

  posName: Joi.string().trim().required().messages({
    'any.required': 'POS name is required.',
    'string.base': 'POS name is invalid.',
    'string.empty': 'POS name is invalid.',
  }),
});

export const MerchantCreatePOSsSchema = Joi.object({
  partnerId: Joi.number().integer().min(1).optional().messages({
    'number.base': 'Partner is invalid.',
    'number.integer': 'Partner is invalid.',
    'number.min': 'Partner must must be at least 1.',
  }),
  resellerId: Joi.number().integer().min(1).optional().messages({
    'number.base': 'Reseller is invalid.',
    'number.integer': 'Reseller is invalid.',
    'number.min': 'Reseller must must be at least 1.',
  }),
  merchantId: Joi.number().integer().min(1).optional().messages({
    'number.base': 'Merchant is invalid.',
    'number.integer': 'merchantId is invalid.',
    'number.min': 'merchantId must must be at least 1.',
  }),
  branchId: Joi.number().integer().min(1).required().messages({
    'any.required': 'Branch is required.',
    'number.base': 'Branch is invalid.',
    'number.integer': 'Branch is invalid.',
    'number.min': 'Branch must must be at least 1.',
  }),

  posName: Joi.string().trim().required().messages({
    'any.required': 'POS name is required.',
    'string.base': 'POS name is invalid.',
    'string.empty': 'POS name is invalid.',
  }),
});
